var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-tooltip',{attrs:{"disabled":!_vm.showTooltip,"content":_vm.content,"placement":"bottom","effect":"light"}},[_c('div',{ref:"contentBox",staticClass:"multi-line-ellipsis",on:{"mouseover":_vm.checkOverflow}},[_vm._t("default")],2)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }